import styled from 'styled-components';

import {
  borderRadius8,
  standardFocusState,
} from 'approot/shared/styles/borders.style';
import { rem } from 'approot/shared/style';
import { grey6 } from 'approot/shared/styles/colours.style';
import { TooltipWrapperStyled } from 'approot/shared/tooltip/tooltip.style';
import { InfoBoxContainer } from 'approot/activity-builder/components/info-box/info-box.style';
import { InfoBoxThoughtView } from 'approot/activity-builder/components/info-box/info-box-thought.style';
import {
  InfoBoxSpeechViewInteractive,
  boxShadowSpeechHover,
} from 'approot/activity-builder/components/info-box/info-box-speech.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/buttons';
import { ACTIVITY_SHEET_CONTENT_MAX_WIDTH } from './components/shared/sheet/activity-sheet.style';
import { spacing24 } from 'approot/shared/styles/spacing.style';

export const ZoomComponentWrapper = styled.div`
  &:hover + ${InfoBoxContainer} {
    ${InfoBoxSpeechViewInteractive}, ${InfoBoxThoughtView} {
      box-shadow: ${boxShadowSpeechHover};
    }
  }
`;

export const ZoomComponentTooltip = styled.div`
  position: absolute;
  width: calc(100% + ${rem(6)});
  height: calc(100% + ${rem(6)});
  left: -${rem(3)};
  top: -${rem(3)};
  z-index: 1;

  ${TooltipWrapperStyled} {
    width: 100%;
    height: 100%;
  }
`;

type ZoomComponentTriggerProps = {
  $hideBorder?: boolean;
};
export const ZoomComponentTrigger = styled.button<ZoomComponentTriggerProps>`
  ${standardFocusState}

  width: 100%;
  height: 100%;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: ${rem(borderRadius8)};

  &:hover {
    border: ${({ $hideBorder }) =>
      $hideBorder ? 'none' : `1px solid ${grey6}`};
  }
`;

export const ZoomComponentContent = styled.div`
  height: 100%;
  display: flex;
`;

export const ZoomComponentContentInner = styled.div`
  margin: auto;
  max-width: ${rem(ACTIVITY_SHEET_CONTENT_MAX_WIDTH)};
  padding: 0 ${rem(spacing24)};
  width: 100%;
`;

export const ZoomComponentModalClose = styled(SecondaryButtonIcon).attrs({
  $borderRadius: 40,
})``;
